import { render, staticRenderFns } from "./variant-grid.vue?vue&type=template&id=17ff977d&"
import script from "./variant-grid.vue?vue&type=script&lang=js&"
export * from "./variant-grid.vue?vue&type=script&lang=js&"
import style0 from "./variant-grid.vue?vue&type=style&index=0&id=17ff977d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports